import React from "react";
import style from "./dressingAppearance.module.scss";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import { signedLockedAccess } from "../../../../utils";
import { ReadOnlyBanner } from "../../../secondary/ReadOnlyBanner/ReadOnlyBanner";
import { PERMISSIONS } from "../../../../constants/permissions";

export const DressingAppearanceViewMode = ({ resp, assessmentDetails, onEdit, isReadOnly, hasPermission }) => (
  <>
    {isReadOnly && (
      <div className="ml-2">
        <ReadOnlyBanner />
      </div>
    )}
    <div className={`row ${style.col_spec}`}>
      <label className="col-5">Dressing Appearance: </label>
      <span className={`col-6 p-0 ${style.first_letter_capital}`}>{resp?.dressingAppearance}</span>
      {signedLockedAccess(assessmentDetails?.assessmentStage) && (
        <button className={style.tab_edit} onClick={onEdit} disabled={!hasPermission(PERMISSIONS.TREATMENT_EDIT)}>
          <img src={editIcon} alt="icon" className={style.e_icon_space} />
          Edit
        </button>
      )}
    </div>
  </>
);
